// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UserContent_root__Z1FWZ {
  border: 1px solid var(--color-theme-bright-gray);
}

.UserContent_user_header__o60-D {
  background-color: var(--color-theme-white);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 20px;
  border-radius: 1px;
  border-bottom: 1px solid var(--color-theme-bright-gray);
}

.UserContent_user_header_deactivated__78F3u {
  background-color: var(--color-theme-bright-gray);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 20px;
  border-radius: 1px;
  color: var(--color-theme-deactivated);
}

.UserContent_user_header_pending__0gt8F {
  background-color: var(--color-theme-white);
  color: var(--color-theme-gray-white);
}

.UserContent_user_header_pending__0gt8F b {
  color: var(--color-font-10);
}

.UserContent_user_name_container__ZuGZt {
  width: 40%;
  display: flex;
}

.UserContent_user_name_container__ZuGZt h2 {
  margin-right: 30px;
}

.UserContent_icon_container__V5dT5 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-right: 20px;
}

.UserContent_icon_container__V5dT5 div {
  font-size: 11px;
}

.UserContent_content_container__edBTo {
  padding: 40px 30px;
  display: flex;
  flex-direction: column;
  align-items: flex-start; /* <--- important! */
}
.UserContent_label__dMY8Z p {
  font-size: 13px !important;
  color: var(--color-theme-red);
  padding: 0px;
  margin: 0px;
}

.UserContent_btn_container__hp3yc {
  display: flex;
  align-items: flex-end;
  width: 50%;
  justify-content: space-between;
}

.UserContent_btn_save_and_send_invite__ao9sY {
  width: 250px;
  font-weight: 600 !important;
  color: var(--color-theme-blue) !important;
  border: 1px solid var(--color-theme-blue) !important;
  height: 40px;
}

.UserContent_btn_save_and_send_invite__ao9sY:disabled {
  width: 250px;
  font-weight: 600 !important;
  color: var(--color-theme-gray-white) !important;
  border: 1px solid var(--color-theme-gray-white) !important;
  height: 40px;
}

.UserContent_btn_send_invite_again__WaXuu {
  width: 250px;
  font-weight: 600 !important;
  color: var(--color-theme-10) !important;
  border: 1px solid var(--color-theme-10) !important;
  height: 40px;
}

.UserContent_btn_save_container__uKZ4A {
  width: 100%;
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  justify-content: flex-end;
  padding: 0px 20px;
}

.UserContent_btn_save__ofy1P {
  width: 170px;
  font-weight: 600 !important;
  color: var(--color-theme-blue) !important;
  border: 1px solid var(--color-theme-blue) !important;
  height: 40px;
}

.UserContent_btn_delete__\\+PdkH {
  width: 200px;
  font-weight: 600 !important;
  color: var(--color-theme-10) !important;
  border: 1px solid var(--color-theme-10) !important;
  height: 40px;
}

.UserContent_btn_cancel__F2SdV {
  width: 120px;
  font-weight: 600 !important;
  color: var(--color-font-red) !important;
  border: 1px solid var(--color-theme-red) !important;
  height: 40px;
}

.UserContent_confirm_btn__5ymho {
  color: var(--color-theme-blue) !important;
  border: 1px solid var(--color-theme-blue) !important;
  width: 174px;
  height: 41px;
  font-weight: bold !important;
}

.UserContent_confirm_btn_disabled__NhOKn {
  color: var(--color-theme-10) !important;
  background-color: var(--color-theme-silver) !important;
  width: 174px;
  height: 41px;
  font-weight: bold !important;
  cursor: auto !important;
}

.UserContent_input_container__05I1y {
  width: 370px !important;
  padding: 5px 0px;
}

.UserContent_accept_container__ZLPUY {
  display: flex;
  align-items: flex-start;
  width: 250px;
  justify-content: space-between;
  margin: 20px 0px;
}

.UserContent_checkbox_label__5crpB {
  font-size: 11px;
}

.UserContent_checkbox_container__z6FY9 {
  width: 100%;
  max-width: 350px;
  border-radius: 5px;
}

.UserContent_columns_wrapper__KAw84 {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.UserContent_column_container__YxyFF {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 370px;
}

.UserContent_bottom_row_container__Q6cSn {
  display: flex;
  align-items: flex-end;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  padding-top: 30px;
}

.UserContent_checkbox_group__FpUdT {
  display: flex;
  flex-direction: column;
  height: 120px;
}

.UserContent_save_button_container__VbLKM {
  height: 120px;
  display: flex;
  align-items: flex-end;
}
`, "",{"version":3,"sources":["webpack://./src/@_components/UserContent/UserContent.module.css"],"names":[],"mappings":"AAAA;EACE,gDAAgD;AAClD;;AAEA;EACE,0CAA0C;EAC1C,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,uDAAuD;AACzD;;AAEA;EACE,gDAAgD;EAChD,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,0CAA0C;EAC1C,oCAAoC;AACtC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB,EAAE,oBAAoB;AAC/C;AACA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,yCAAyC;EACzC,oDAAoD;EACpD,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,+CAA+C;EAC/C,0DAA0D;EAC1D,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,uCAAuC;EACvC,kDAAkD;EAClD,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,yCAAyC;EACzC,oDAAoD;EACpD,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,uCAAuC;EACvC,kDAAkD;EAClD,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,uCAAuC;EACvC,mDAAmD;EACnD,YAAY;AACd;;AAEA;EACE,yCAAyC;EACzC,oDAAoD;EACpD,YAAY;EACZ,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,uCAAuC;EACvC,sDAAsD;EACtD,YAAY;EACZ,YAAY;EACZ,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;EACX,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,aAAa;EACb,qBAAqB;AACvB","sourcesContent":[".root {\n  border: 1px solid var(--color-theme-bright-gray);\n}\n\n.user_header {\n  background-color: var(--color-theme-white);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0px 20px;\n  border-radius: 1px;\n  border-bottom: 1px solid var(--color-theme-bright-gray);\n}\n\n.user_header_deactivated {\n  background-color: var(--color-theme-bright-gray);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0px 20px;\n  border-radius: 1px;\n  color: var(--color-theme-deactivated);\n}\n\n.user_header_pending {\n  background-color: var(--color-theme-white);\n  color: var(--color-theme-gray-white);\n}\n\n.user_header_pending b {\n  color: var(--color-font-10);\n}\n\n.user_name_container {\n  width: 40%;\n  display: flex;\n}\n\n.user_name_container h2 {\n  margin-right: 30px;\n}\n\n.icon_container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding-right: 20px;\n}\n\n.icon_container div {\n  font-size: 11px;\n}\n\n.content_container {\n  padding: 40px 30px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start; /* <--- important! */\n}\n.label p {\n  font-size: 13px !important;\n  color: var(--color-theme-red);\n  padding: 0px;\n  margin: 0px;\n}\n\n.btn_container {\n  display: flex;\n  align-items: flex-end;\n  width: 50%;\n  justify-content: space-between;\n}\n\n.btn_save_and_send_invite {\n  width: 250px;\n  font-weight: 600 !important;\n  color: var(--color-theme-blue) !important;\n  border: 1px solid var(--color-theme-blue) !important;\n  height: 40px;\n}\n\n.btn_save_and_send_invite:disabled {\n  width: 250px;\n  font-weight: 600 !important;\n  color: var(--color-theme-gray-white) !important;\n  border: 1px solid var(--color-theme-gray-white) !important;\n  height: 40px;\n}\n\n.btn_send_invite_again {\n  width: 250px;\n  font-weight: 600 !important;\n  color: var(--color-theme-10) !important;\n  border: 1px solid var(--color-theme-10) !important;\n  height: 40px;\n}\n\n.btn_save_container {\n  width: 100%;\n  display: flex;\n  align-items: flex-end;\n  flex-direction: column;\n  justify-content: flex-end;\n  padding: 0px 20px;\n}\n\n.btn_save {\n  width: 170px;\n  font-weight: 600 !important;\n  color: var(--color-theme-blue) !important;\n  border: 1px solid var(--color-theme-blue) !important;\n  height: 40px;\n}\n\n.btn_delete {\n  width: 200px;\n  font-weight: 600 !important;\n  color: var(--color-theme-10) !important;\n  border: 1px solid var(--color-theme-10) !important;\n  height: 40px;\n}\n\n.btn_cancel {\n  width: 120px;\n  font-weight: 600 !important;\n  color: var(--color-font-red) !important;\n  border: 1px solid var(--color-theme-red) !important;\n  height: 40px;\n}\n\n.confirm_btn {\n  color: var(--color-theme-blue) !important;\n  border: 1px solid var(--color-theme-blue) !important;\n  width: 174px;\n  height: 41px;\n  font-weight: bold !important;\n}\n\n.confirm_btn_disabled {\n  color: var(--color-theme-10) !important;\n  background-color: var(--color-theme-silver) !important;\n  width: 174px;\n  height: 41px;\n  font-weight: bold !important;\n  cursor: auto !important;\n}\n\n.input_container {\n  width: 370px !important;\n  padding: 5px 0px;\n}\n\n.accept_container {\n  display: flex;\n  align-items: flex-start;\n  width: 250px;\n  justify-content: space-between;\n  margin: 20px 0px;\n}\n\n.checkbox_label {\n  font-size: 11px;\n}\n\n.checkbox_container {\n  width: 100%;\n  max-width: 350px;\n  border-radius: 5px;\n}\n\n.columns_wrapper {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.column_container {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  width: 370px;\n}\n\n.bottom_row_container {\n  display: flex;\n  align-items: flex-end;\n  width: 100%;\n  flex-direction: row;\n  justify-content: space-between;\n  padding-top: 30px;\n}\n\n.checkbox_group {\n  display: flex;\n  flex-direction: column;\n  height: 120px;\n}\n\n.save_button_container {\n  height: 120px;\n  display: flex;\n  align-items: flex-end;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `UserContent_root__Z1FWZ`,
	"user_header": `UserContent_user_header__o60-D`,
	"user_header_deactivated": `UserContent_user_header_deactivated__78F3u`,
	"user_header_pending": `UserContent_user_header_pending__0gt8F`,
	"user_name_container": `UserContent_user_name_container__ZuGZt`,
	"icon_container": `UserContent_icon_container__V5dT5`,
	"content_container": `UserContent_content_container__edBTo`,
	"label": `UserContent_label__dMY8Z`,
	"btn_container": `UserContent_btn_container__hp3yc`,
	"btn_save_and_send_invite": `UserContent_btn_save_and_send_invite__ao9sY`,
	"btn_send_invite_again": `UserContent_btn_send_invite_again__WaXuu`,
	"btn_save_container": `UserContent_btn_save_container__uKZ4A`,
	"btn_save": `UserContent_btn_save__ofy1P`,
	"btn_delete": `UserContent_btn_delete__+PdkH`,
	"btn_cancel": `UserContent_btn_cancel__F2SdV`,
	"confirm_btn": `UserContent_confirm_btn__5ymho`,
	"confirm_btn_disabled": `UserContent_confirm_btn_disabled__NhOKn`,
	"input_container": `UserContent_input_container__05I1y`,
	"accept_container": `UserContent_accept_container__ZLPUY`,
	"checkbox_label": `UserContent_checkbox_label__5crpB`,
	"checkbox_container": `UserContent_checkbox_container__z6FY9`,
	"columns_wrapper": `UserContent_columns_wrapper__KAw84`,
	"column_container": `UserContent_column_container__YxyFF`,
	"bottom_row_container": `UserContent_bottom_row_container__Q6cSn`,
	"checkbox_group": `UserContent_checkbox_group__FpUdT`,
	"save_button_container": `UserContent_save_button_container__VbLKM`
};
export default ___CSS_LOADER_EXPORT___;
